import { connect } from "react-redux";
import TrainingChecklist from "./trainingChecklist";
import { bindActionCreators } from "redux";
import {
  getDashboardTrainingChecklist,
  postTrainingChecklistData
} from "services/redux/installation/civilCheckList/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  dashboardTraining: state.civilReducer.dashboardTrainingChecklist,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDashboardTrainingChecklist,
      documentUploadUrl,
      postTrainingChecklistData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TrainingChecklist);
